<template>
  <div class="number-input">
    <button
      type="button"
      class="number-input__decrease btn btn-outline-secondary"
      @click="decrease"
      :disabled="disabled"
    >
      <span class="mi mi-minus"></span>
    </button>
    <slot></slot>
    <button
      type="button"
      class="number-input__increase btn btn-outline-secondary"
      @click="increase"
      :disabled="disabled"
    >
      <span class="mi mi-plus"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'InputSpinners',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    decrease() {
      this.$emit('decrease');
    },
    increase() {
      this.$emit('increase');
    },
  },
};
</script>
